import { Vue } from "vue-property-decorator";
import AiAddDevice from "./AiAddDevice";
import AiMediaViewerModal from "./AiMediaViewerModal";
import AiRenameDeviceModal from "./AiRenameDeviceModal";
import AiProductDocumentList from "./AiProductDocumentList";
import AiHtmlView from "./AiHtmlView";
import AiDealerDetails from "./AiDealerDetails";
import AiChart from "./AiChart";
import AiChartOptionsModal from "./AiChartOptionsModal";
import AiSaveSensorLogModal from "./AiSaveSensorLogModal";
Vue.mixin({
    components: {
        AiAddDevice: AiAddDevice,
        AiMediaViewerModal: AiMediaViewerModal,
        AiRenameDeviceModal: AiRenameDeviceModal,
        AiProductDocumentList: AiProductDocumentList,
        AiHtmlView: AiHtmlView,
        AiDealerDetails: AiDealerDetails,
        AiChart: AiChart,
        AiChartOptionsModal: AiChartOptionsModal,
        AiSaveSensorLogModal: AiSaveSensorLogModal,
    }
});
